export default __webpack_public_path__ + "static/media/ScrollWhite.ff06fc74.svg";